module.exports = __webpack_public_path__ + "img/s2P31.5a5bb37b.png";